import type { InvoiceDetails } from '@features/invoices/api/types/invoice-details.types';
import type { UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@contexts/auth-provider/hooks/use-auth/useAuth';
import { useOrganizations } from '@contexts/organizations-provider';
import { getInvoiceDetails } from '@features/invoices/api/get-invoice-details/getInvoiceDetails';
import { useQuery } from '@tanstack/react-query';

import type {
  UseInvoiceDetailsParams,
  UseInvoiceDetailsReturn,
} from './useInvoiceDetails.types';

export function useInvoiceDetails({
  accountReceivableId,
}: UseInvoiceDetailsParams): UseInvoiceDetailsReturn {
  const { isAuthenticated } = useAuth();
  const { selectedOrganization } = useOrganizations();
  const organizationId = selectedOrganization?.id ?? '';

  const invoiceDetails: UseQueryResult<InvoiceDetails, Error> = useQuery<
    InvoiceDetails,
    Error
  >({
    queryKey: ['invoices', 'details', organizationId, accountReceivableId],
    queryFn: () =>
      getInvoiceDetails({
        accountReceivableId,
        organizationId,
      }),
    enabled: isAuthenticated && !!selectedOrganization,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { invoiceDetails };
}
